import React from "react";
import { Navbar, NavLink, Nav } from "react-bootstrap";
import { Label, Logo } from "@nentech/charmanender-ui";

import "./scss/NavigationBar.scss";

const NavigationBar = ({
  profileData,
  session,
  signedInPlaceholder,
  logoutPlaceholder,
  desktopAsset,
  mobileAsset,
  onClickLogout,
}) => (
  <>
    <Navbar
      collapseOnSelect
      fixed="top"
      expand="lg"
      className={"navbar border-bottom border-dark"}
    >
      <div
        className={
          "navbar-container d-flex flex-wrap align-items-center justify-content-between"
        }
      >
        <Navbar.Brand href="home">
          <Logo desktopAsset={desktopAsset} mobileAsset={mobileAsset} />
        </Navbar.Brand>

        {!!session && session === "active" && (
          <>
            <Navbar.Toggle aria-controls="basic-navbar-nav"/>
            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">

            <Nav className="me-auto">
              <Nav.Link href="home">Home</Nav.Link>
            </Nav>

              <Navbar.Text
                style={{
                  marginRight: 16,
                  fontWeight: "bold",
                }}
              >
                <Label
                  bold
                  text={`${signedInPlaceholder} ${profileData?.name} ${profileData?.surname}`}
                />
              </Navbar.Text>

              <NavLink
                style={{
                  textDecoration: "underline",
                }}
                onClick={onClickLogout}
              >
                {logoutPlaceholder}
              </NavLink>
            </Navbar.Collapse>
          </>
        )}
      </div>
    </Navbar>
  </>
);

export default NavigationBar;